module.exports = __webpack_public_path__ + "static/media/vector-square.a749bfac.svg";